/**
 * Connexion admin pour configurer la pointeuse
 * @param email - Email de l'admin
 * @param password - Mot de passe
 * @returns Informations de l'admin connecté
 */

import { LoginResponse, PointeuseLoginResponse } from "@/types/auth.types";
import { api } from "./api";
import { ApiError } from "@/types/workSessions.type";
import axios from "axios";
export const loginAdmin = async (
  email: string,
  password: string
): Promise<LoginResponse> => {
  try {
    const response = await api.post<LoginResponse>("/auth/login", {
      email,
      password,
    });

    if (
      response.data.user.role !== "SUPERUSER" &&
      response.data.user.role !== "ADMIN"
    ) {
      throw new Error(
        "Vous n'avez pas les permissions nécessaires pour configurer la pointeuse"
      );
    }

    if (!response.data.user.companyId) {
      throw new Error("Cet administrateur n'est associé à aucune entreprise");
    }

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Erreur réseau (pas de réponse du serveur)
      if (!error.response) {
        throw new Error(
          "Impossible de se connecter au serveur. Vérifiez que le serveur est démarré et que vous êtes connecté à internet."
        );
      }
      // Erreur serveur (avec réponse)
      const apiError = error.response?.data as ApiError | undefined;
      throw new Error(
        apiError?.message || "Une erreur est survenue lors de la connexion"
      );
    }
    throw new Error("Une erreur est survenue lors de la connexion");
  }
};

/**
 * Connexion pointeuse avec login et password de l'entreprise
 * @param login - Login pointeuse de l'entreprise
 * @param password - Mot de passe pointeuse de l'entreprise
 * @returns Informations de l'entreprise connectée avec token
 */

export const loginPointeuse = async (
  login: string,
  password: string
): Promise<PointeuseLoginResponse> => {
  try {
    const response = await api.post<PointeuseLoginResponse>(
      "/auth/login-pointeuse",
      {
        login,
        password,
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Erreur réseau (pas de réponse du serveur)
      if (!error.response) {
        throw new Error(
          "Impossible de se connecter au serveur. Vérifiez que le serveur est démarré et que vous êtes connecté à internet."
        );
      }
      // Erreur serveur (avec réponse)
      const apiError = error.response?.data as ApiError | undefined;
      throw new Error(
        apiError?.message || "Une erreur est survenue lors de la connexion"
      );
    }
    throw new Error("Une erreur est survenue lors de la connexion");
  }
};

export const verifyPointeusePassword = async (
  password: string
): Promise<{ message: string }> => {
  try {
    const response = await api.post<{ message: string }>(
      "/auth/pointeuse/verify-password",
      { password }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (!error.response) {
        throw new Error(
          "Impossible de se connecter au serveur. Vérifiez votre connexion."
        );
      }

      const apiError = error.response?.data as ApiError | undefined;
      throw new Error(apiError?.message || "Mot de passe incorrect");
    }

    throw new Error("Une erreur est survenue lors de la verification");
  }
};
